import clipboard from '../../clipboard';
import hdrm from '../../hdrm';
import { UPDATE_LIVE_ONLY } from '../../hdrm/constants/update-strategies';

import actionTypes from '../constants/action-types';

const copyElement = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.CUT_ELEMENT:
    case actionTypes.COPY_ELEMENT: {
      const { elementId, options } = action.payload;
      const { strategy } = options;
      const element =
        strategy === UPDATE_LIVE_ONLY
          ? hdrm.accessors.getLiveElement(elementId)
          : hdrm.accessors.getStaticElement(elementId);

      if (!element) {
        throw new Error('Element with specified id does not exists');
      }

      store.dispatch(
        clipboard.actions.setClipboardData({
          element: document.importNode(element, true),
          options,
        })
      );

      next(action);

      break;
    }
    default:
      next(action);
  }
};

export default copyElement;
